/**
 * Date picker background based on theming
 */
export default (theme) => ({
    customDatePickerStyle: {
        "& .react-datepicker__header, & .react-datepicker__day--selected, & .react-datepicker__day--in-selecting-range, & .react-datepicker__day--in-range, & .react-datepicker__month-text--selected, & .react-datepicker__month-text--in-selecting-range, & .react-datepicker__month-text--in-range, & .react-datepicker__quarter-text--selected, & .react-datepicker__quarter-text--in-selecting-range,& .react-datepicker__quarter-text--in-range, & .react-datepicker__year-text--selected,& .react-datepicker__year-text--in-selecting-range,& .react-datepicker__year-text--in-range, & .react-datepicker__time-container & .react-datepicker__time & .react-datepicker__time-box & ul.react-datepicker__time-list & li.react-datepicker__time-list-item--selected, & .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected, & .react-datepicker__day--keyboard-selected":
            {
                background: theme.palette.primary.main
            },
        width:"100%"
    },
    datePickerWrapper: {
        width: "100%"
    }
});
